import { render } from "./TaskHistory.vue?vue&type=template&id=3772a4d3&scoped=true"
import script from "./TaskHistory.vue?vue&type=script&lang=js"
export * from "./TaskHistory.vue?vue&type=script&lang=js"

import "./TaskHistory.vue?vue&type=style&index=0&id=3772a4d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3772a4d3"]])

export default __exports__